import { createContext } from 'react';
import { IBasicOrganization } from '../resources/models/IOrganization';

export enum EOrganizationSelectionStatus {
  NotSelected,
  Skipped,
  Default,
  Selected,
  Injected,
}

export interface IOrganizationContext {
  selectionStatus: EOrganizationSelectionStatus;
  organization: IBasicOrganization | null;
  organizationId: string | null;
  setOrganization: (organization: IBasicOrganization | null) => void;
}

export const OrganizationContext = createContext<IOrganizationContext>({
  selectionStatus: EOrganizationSelectionStatus.NotSelected,
  organization: null,
  organizationId: null,
  setOrganization: () => void 0,
});
